import React, { Component } from 'react';
import { array, bool, func, object } from 'prop-types';
import { connect } from 'react-redux';

import { resetAnnotation } from 'PipeRouter';

import CSS from './styles.css';
import MainSlatViews from './views';


const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

class MainSlat extends Component {
  constructor(props) {
    super(props);
  }

  onKeyDown = event => {
    const { target } = event;
    const name = target.children && target.children[1] && target.children[1].textContent;
    const { markers, resetAnnotation } = this.props;

    if (event.keyCode === keys.tab && name === 'Add Note') {
      const firstMarker = markers.filter(marker => marker.sortOrder === 1);
      const markerId = firstMarker[0].id;

      if (event.shiftKey) {
        const buttonExists = target.parentElement.parentElement.children[0].getElementsByTagName('button')[0];
        const svgExists = target.parentElement.parentElement.children[0].children[0].children[0].children[3].children[1];

        if (buttonExists) {
          buttonExists.focus();
        } else {
          svgExists.focus();
        }

        event.preventDefault();
        return;
      }

      document.getElementById(markerId).focus();
      event.preventDefault();
      return;
    }

    if (event.keyCode === keys.tab ) {
      if (event.shiftKey) {
        if (target.tagName === 'svg') {
          const onMarkerId = target.parentElement.getElementsByTagName('input')[0].id;

          for (let i=0, len=markers.length; i<len; i++) {
            if (onMarkerId === markers[i].id && markers[i].sortOrder === 1) {
              event.currentTarget.children[1].getElementsByTagName('button')[0].focus();
              event.preventDefault();
              break;
            }
          }
          return;
        }
      }
    }

    if (event.keyCode === keys.esc) {
      resetAnnotation();
      return;
    }
  };

  render() {
    const { isNoteEditorOpen, position, selectedHighlight } = this.props;

    const container = position.arrow === 'top'
      ? CSS['containerWithArrow']
      : CSS['containerWithTopArrow'];

    const styles = {
      top: position.y,
      left: position.x
    };

    const viewProps = {
      container,
      isNoteEditorOpen,
      selectedHighlight,
      styles,
      onKeyDown: this.onKeyDown
    };

    return <MainSlatViews { ...viewProps } />;
  }
}

MainSlat.propTypes = {
  isNoteEditorOpen: bool,
  markers: array,
  position: object,
  resetAnnotation: func,
  selectedHighlight: object
};

function mapStateToProps(state) {
  const { annotation, mainslat, markers, selectedHighlight } = state;
  const { position } = annotation;
  const { isNoteEditorOpen } = mainslat;

  return {
    isNoteEditorOpen: mainslat.isNoteEditorOpen,
    position: annotation.position,
    markers,
    selectedHighlight
  };
}

export default connect(mapStateToProps, {
  resetAnnotation
})(MainSlat);
